// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import _ from 'lodash';
import { getAvailableQuantity, determineWinningCombo, setSatisfiersToWinningCombo } from './common';
import getTotalProductCombinations from './get-total-product-combinations';
import { orderProductsForDiscountPrecedence } from '../utilities';

const checkTotalSpend = ({
  bogoCalcsData,
  conditions,
  items,
  itemToConsiderLast,
  itemsForAPrice,
  logicOperator,
  pendingRewardsSatisfiers,
  specialsSettings,
  totalQuantity,
  totalSpend,
  specialId,
}) => {
  const { minimumSpend: spendTarget, maximumSpend: spendTargetMax, spendOperator } = totalSpend;
  let satisfied = false;
  let satisfiers = {};

  const uniqueConditions = conditions.length > 0 ? _.uniqBy(_.flatMap(conditions, 'eligibleItems'), 'key') : items;
  const eligibleItems = orderProductsForDiscountPrecedence(
    uniqueConditions,
    specialsSettings,
    itemsForAPrice.enabled ? 'rewards' : 'conditions'
  );

  const availableEligibleItems = _.reduceRight(
    eligibleItems,
    (accumulator, item) => {
      const basePrice = Big(item.mixAndMatch?.adjustedBasePrice || item?.basePrice || 0);
      // If item is weighted
      if (basePrice.gt(0)) {
        const availableQuantity = getAvailableQuantity({
          item,
          bogoCalcsData,
          pendingConditionsSatisfiers: satisfiers,
          pendingRewardsSatisfiers,
          excludeDefeatedRewardsSatisfiers: itemsForAPrice?.enabled,
          specialId,
        });
        if (availableQuantity > 0) {
          accumulator.push({
            item,
            key: item.key,
            quantity: availableQuantity,
            basePrice: Number(basePrice.times(100)),
          });
        }
      }
      return accumulator;
    },
    []
  );

  if (availableEligibleItems.length < 1) {
    return { satisfied, satisfiers };
  }

  const spendTargetInCents = Number(spendTarget * 100);

  // NOTE: total spend with a between operator doesn't matter here
  const combinations = getTotalProductCombinations(
    availableEligibleItems,
    spendOperator,
    spendTargetInCents,
    totalQuantity,
    'basePrice'
  );

  // total spend with a between operator will always win out here
  if (spendOperator === 'between') {
    const combinedTotal = _.reduce(
      availableEligibleItems,
      (prev, curr) => +prev + +curr.item.basePrice * curr.quantity,
      0
    );
    const isTotalBetween = combinedTotal >= spendTarget && combinedTotal <= spendTargetMax;
    if (isTotalBetween) {
      satisfiers = _.reduce(
        availableEligibleItems,
        (result, item) => {
          result[item.key] = { item: item.item, quantity: item.quantity };
          return result;
        },
        {}
      );
      return {
        satisfied: true,
        satisfiers,
      };
    }
  }

  if (combinations.length < 1) {
    return { satisfied, satisfiers };
  }

  const winningCombination = determineWinningCombo(combinations, itemToConsiderLast, conditions, logicOperator);

  if (winningCombination) {
    satisfied = true;
    satisfiers = setSatisfiersToWinningCombo(winningCombination);
  }

  return { satisfied, satisfiers };
};

export default checkTotalSpend;
